import { getModel } from "../modelHelper";
import { onTurboPageLoad, reloadWithTurbo } from "../turboHelper";
import * as Turbo from "@hotwired/turbo";
import { formSubmitWithWaitForJobCompletion } from "../jobCompletion";
import { applyChildElementsFilter } from "../helpers";

onTurboPageLoad("Tours/AddDestinationLevelPoisToTour", () => {
    const model = getModel<IAddDestinationLevelPoisToTourModel>();

    const addPoiToTourForms = $("form[name='addPoiToTourForm'");

    $.each(addPoiToTourForms, (index, form) => {
        const submitButton = $(form).find("button[name='submit']");

        formSubmitWithWaitForJobCompletion(
            $(form),
            submitButton,
            model.getJobUrl,
            () => {
                reloadWithTurbo();
            },
            "Really add Place to the tour?"
        );
    });

    $(".cancelButton").on("click", () => {
        Turbo.clearCache();
        history.back();
    });

    applyChildElementsFilter(document.querySelector('input.filter-pois') as HTMLInputElement, document.querySelector('div.pois-container') as HTMLElement, 'div.poi');
});

interface IAddDestinationLevelPoisToTourModel {
    getJobUrl: string;
    tourUniqueId: string;
}
